import documentApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleDocuments';

type ThisApi = ApiDefinition['/document-request-users/{documentRequestUserId}/means-test']['POST'];
type Input = ThisApi['params'];

const syncMeansTestDataWithSchedules = async ({ documentRequestUserId }: Input): Promise<ThisApi['response']> => {
  const response = await documentApiClient.post(`/document-request-users/${documentRequestUserId}/means-test`);
  return response.data;
};

export default syncMeansTestDataWithSchedules;
